export default __webpack_public_path__ + "static/KeywordResearch_02_04@2x-387eacd5dd91dfa79ef80daafb361062.png";